import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { useLocalStorage } from 'contexts/useLocalStorage';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useFlags } from 'launchdarkly-react-client-sdk';

const InstantPayoutNotification = () => {
    const { instantPayouts = false } = useFlags();
    const { instantEligible, hasUsedInstantPayouts } = useCurrentAccount();
    const { hasDismissedInstantPayoutsNotification, setHasDismissedInstantPayoutsNotification } =
        useLocalStorage(state => state);
    const showNotification =
        instantPayouts &&
        instantEligible &&
        !hasUsedInstantPayouts &&
        !hasDismissedInstantPayoutsNotification;

    if (!showNotification) {
        return null;
    }

    return (
        <AlertNotification.Root type="info">
            <AlertNotification.Icon />
            <AlertNotification.Content>
                <AlertNotification.Title>New</AlertNotification.Title>
                <AlertNotification.Description>
                    You're eligible for Instant Payouts to receive deposits to your bank account
                    within 30 minutes, including holidays and weekends.
                </AlertNotification.Description>
            </AlertNotification.Content>
            <AlertNotification.Close
                onClick={() => setHasDismissedInstantPayoutsNotification(true)}
            />
        </AlertNotification.Root>
    );
};

export { InstantPayoutNotification };
